import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Modal from 'react-bootstrap/Modal';
import { useAppDispatch, useAppSelector } from '../../services/hooks';
import { isResellerOrSuper } from '../../helpers/user';
import { Link } from 'react-router';
import { logout, setModalShow } from '../../stores/user/userSlice';
import { useTranslation } from 'react-i18next';

export default function HeaderAccountModalLogged() {
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const showAccountModal = useAppSelector((state) => state.user.auth.modalShow);
    const role = useAppSelector((state) => state.user.reseller);
    const admin = useAppSelector((state) => state.user.admin);
    const email = useAppSelector((state) => state.user.email);

    function onHide() {
        dispatch(setModalShow(false))
    }

    return (
        <Modal show={showAccountModal} onHide={onHide} id="accountNavModal" aria-labelledby="NavModal"
            dialogClassName='modalDialogBasket modal-sm breakWord'>
            <Modal.Header>
                <button type="button" onClick={onHide} className="btn-close" aria-label="Close" />
            </Modal.Header>
            <Modal.Body>
                <Container fluid>
                    <div className="small text-center py-2">
                        {t('header.modal.account.welcome.header')}&nbsp;
                        {isResellerOrSuper(role)
                            ? t('header.modal.account.welcome.distributor')
                            : t('header.modal.account.welcome.client')
                        }
                    </div>

                    <form className="needs-validation" noValidate={true} id="loginForm" action="/api/login"
                        method="post">
                        <Row>
                            <Col xs={12}>
                                <Row className='text-center'>
                                    <Col xs={12}>
                                        <img src="/tpl/assets/img/profileImgMaleDark.svg"
                                            className="img-fluid w-25 m-auto" alt="" />
                                    </Col>
                                    <Col xs={12} className='my-3'>
                                        <p className="my-0">{email}</p>
                                    </Col>
                                    <Col xs={12} className='pb-3'>
                                        {admin && <Link to={'/admin'} reloadDocument>
                                            <Button onClick={onHide} size='sm' variant='outline-danger'
                                                className="bi bi-gear-wide rounded-3 border-2">
                                                &nbsp;Admin
                                            </Button>
                                        </Link>}
                                    </Col>
                                    <Col xs={6}>
                                        <Link to={'/dashboard'}>
                                            <Button onClick={onHide} size='sm' variant='outline-success'
                                                className="bi bi-gear-wide rounded-3 border-2">
                                                &nbsp;{t('header.modal.account.manage')}
                                            </Button>
                                        </Link>
                                    </Col>
                                    <Col xs={6}>
                                        <Button onClick={async () => {
                                            await dispatch(logout());
                                            window.location.reload()
                                        }} size='sm' variant='outline-dark'
                                            className="bi bi-box-arrow-in-right rounded-3 border-2">
                                            &nbsp;{t('header.modal.account.logout')}
                                        </Button>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </form>
                </Container>
            </Modal.Body>
            <Modal.Footer />
        </Modal>
    )
}